import { AutocompleteRenderValueGetItemProps, Chip } from '@mui/material';
import React from 'react';
import style from './index.module.scss';
import { ColoredOptionIcon } from '../helpers';

// MUI 9: Autocomplete's renderTags(value, getTagProps) is renderValue(value, getItemProps)
const renderColoredIconTags = (
  value: ColoredOptionIcon[],
  getItemProps: AutocompleteRenderValueGetItemProps<true>,
) => {
  return value.map((option, index) => {
    const Icon = option.Icon;
    const color = option.color ?? undefined;
    // React 19: `key` must not travel in a spread
    const { key, ...itemProps } = getItemProps({ index });
    return (
      <Chip
        key={key}
        avatar={<Icon fontSize={'small'} style={{ color }} />}
        variant="outlined"
        label={option.title || ''}
        {...itemProps}
        classes={{
          root: style.chipRoot,
          avatar: style.chipAvatar,
          deleteIcon: style.chipDeleteIcon,
        }}
        style={{
          color,
          borderColor: color,
        }}
      />
    );
  });
};

export default renderColoredIconTags;
